export const MESSAGES = {
  REQUEST_ERROR: "Fail to fetch attendance history",
  NO_REQUESTS_AVAILABLE: "No Attendance History",
  SITES_NAME_REQUIRED: "Site name is required",
  DATE_REQUIRED: "Date is required",
  TIME_REQUIRED: "Time is required",
  FUTURE_DATE_ERROR: "Date cannot be today or in the future",
  LOCATION_DENIED_ERROR: "Cannot get location",
  SELFIE_REQUIRED: "Please take a selfie before submitting.",
  SUBMITTED_ATTENDANCE: (time) => `Attendance Submitted on ${time}`,
  ENTRY_ALREADY_EXISTS: "An entry already exists for the day",
  ENTRY_SUBMITTED: "Entry Submitted Successfully",
  FAILED_SUBMISSION: "Failed to submit attendance.",
  SITES_ERROR: "Error fetching sites",
  LOCATION_NOT_AVAILABLE: "Location Not available",
  PHOTO_NOT_AVAILABLE: "Photo Not available",
  MAP_LOADING_ERROR: "Error Loading Map",
  CAMERA_ERROR: "Camera Error: ",
  CHECKOUT_PRE_CHECKIN: "CheckOut time can not be post CheckIn time",
  ATTENDANCE_UPDATE_SUCCESS: (action) => `Attendance ${action} successfully`,
  ATTENDANCE_UPDATE_UNAUTHORIZED: "You do not have the authority to update this status",
  ATTENDANCE_UPDATE_FAILED: "Failed to update status",
  USER_FETCH_ERROR: "Failed to Fetch Users",
  NOT_IN_SITE_RETRY: "You are not within the selected site's geofence. Kindly Retry..!",
};

export const ATTENDANCE_COLUMNS = [
  "user_name",
  "site_name",
  "date",
  "checkin_time",
  "checkout_time",
  "is_backdated",
  "status",
  "actions",
];

export const ATTENDANCE_LABELS = {
  user_name: "User Name",
  site_name: "Site",
  date: "Date",
  checkin_time: "Check-in Time",
  checkout_time: "Check-out Time",
  is_backdated: "Backdated",
  status: "Approval Status",
  actions: "Actions",
};

export const ATTENDANCE_TYPES = {
  CHECKIN: "checkin",
  CHECKOUT: "checkout",
};

export const ADMIN_ATTENDANCE_TABLE_COLUMNS = [
  "user_name",
  "site_name",
  "date",
  "checkin_time",
  "checkout_time",
  "is_backdated",
  "status",
  "actions",
];

export const ADMIN_ATTENDANCE_COLUMN_LABELS = {
  user_name: "Username",
  site_name: "Site",
  date: "Date",
  checkin_time: "Check-In Time",
  checkout_time: "Check-Out Time",
  is_backdated: "Backdated",
  status: "Status",
  actions: "Actions",
};

export const EXCEL_FILE_COLUMNS = [
  { label: "Site Name", value: "site_name" },
  { label: "User Name", value: "user_name" },
  { label: "Date", value: "date" },
  { label: "Check-In Time", value: "checkin_time" },
  { label: "Check-Out Time", value: "checkout_time" },
  { label: "Is Backdated", value: "is_backdated" },
  { label: "Status", value: "status" },
  { label: "Check IN Photo", value: "checkin_photo_url" },
  { label: "Check OUT Photo", value: "checkout_photo_url" },
];

export const AUTO_APPROVED = "AUTO_APPROVED";
export const ACTION_AUTO_APPROVED = "auto approved";
export const ACTION_APPROVED = "approved";
export const ACTION_REJECTED = "rejected";
export const APPROVED = "APPROVED";
export const REJECTED = "REJECTED";
export const PENDING = "PENDING";
export const IN_PROGRESS = "IN_PROGRESS";
export const PENDING_L1_APPROVAL = "PENDING_L1_APPROVAL";
export const PENDING_L2_APPROVAL = "PENDING_L2_APPROVAL";

export const FILTER_FILEDS = ["status", "date"];
export const ATTENDANCE_ERROR = "Failed to fetch attendance data";
export const USERDATA_ERROR = "Failed to fetch user data";
export const ATTENDANCE_STATUS_ERROR = "Failed to update attendance status";
export const TASK_ERROR = "Failed to fetch task data";
export const TASK_WARNING = "Task not assigned for today";
export const INCOMPLETE_TASK_WARNING = "Assigned Task not completed";
export const ERROR_FETCHING_GEOFENCE = "Error fetching site geofence";

export const STATUS_LABELS = {
  AUTO_APPROVED: { text: "Auto Approved", className: "text-green-600 font-medium" },
  APPROVED: { text: "Approved", className: "text-green-600 font-medium" },
  REJECTED: { text: "Rejected", className: "text-red-600 font-medium" },
  PENDING_L1_APPROVAL: {
    text: "Pending L1 Approval",
    className: "text-gray-600 font-medium",
  },
  PENDING_L2_APPROVAL: {
    text: "Pending L2 Approval",
    className: "text-gray-600 font-medium",
  },
  DEFAULT: { text: "Pending L1 Approval", className: "text-gray-500" },
};

export const STATUS_FILTER_OPTIONS = [
  { value:"", label:"All"},
  { value: AUTO_APPROVED, label: "Auto Approved" },
  { value: APPROVED, label: "Approved" },
  { value: REJECTED, label: "Rejected" },
  { value: PENDING_L1_APPROVAL, label: "Pending L1 Approval" },
  { value: PENDING_L2_APPROVAL, label: "Pending L2 Approval" },
];